import { createLucideIcon } from 'lucide-react';
export const Payment = createLucideIcon('payment', [
  [
    'path',
    {
      d: 'M12 10.5C12.1815 10.5 12.4208 10.6011 12.6388 10.8814C12.8522 11.1558 13 11.5534 13 12C13 12.4466 12.8522 12.8442 12.6388 13.1186C12.4208 13.3989 12.1815 13.5 12 13.5C11.8185 13.5 11.5792 13.3989 11.3612 13.1186C11.1478 12.8442 11 12.4466 11 12C11 11.5534 11.1478 11.1558 11.3612 10.8814C11.5792 10.6011 11.8185 10.5 12 10.5Z',
      key: '1vylgb',
    },
  ],
  [
    'path',
    {
      d: 'M18.0669 11.311C17.9497 11.4283 17.7908 11.4941 17.625 11.4941C17.4592 11.4941 17.3003 11.4283 17.1831 11.311C17.0658 11.1938 17 11.0349 17 10.8691C17 10.7033 17.0658 10.5444 17.1831 10.4272C17.3003 10.3099 17.4592 10.2441 17.625 10.2441C17.7908 10.2441 17.9497 10.3099 18.0669 10.4272C18.1842 10.5444 18.25 10.7033 18.25 10.8691C18.25 11.0349 18.1842 11.1938 18.0669 11.311Z',
      key: '1keicg',
    },
  ],
  [
    'path',
    {
      d: 'M19 16.8251C18.6629 16.7807 18.3254 16.7504 17.9884 16.7344C15.6172 16.6227 14.725 16.671 12.1125 17.8355C9.5 19 7.8385 19.2476 5 18.8953',
      key: '1rpf7b',
    },
  ],
  [
    'path',
    {
      d: 'M19 16.8251C19 16.8251 19 15 20 14.5C21 14 22 14.5 22 14.5',
      key: '3nis3l',
    },
  ],
  [
    'path',
    {
      d: 'M19 16.8251C19.0642 16.8335 19.1285 16.8425 19.1927 16.8519C20.0232 16.9743 20.8511 17.1815 21.6663 17.47L22 17.5882V15V14.5',
      key: '1goj40',
    },
  ],
  [
    'path',
    {
      d: 'M19.5 6C19 6.5 19.1927 7.5 19.5 8C20.2405 9.2048 22 8.5 22 8.5',
      key: 'sbr3cd',
    },
  ],
  [
    'path',
    {
      d: 'M19.5 6L22 6.5V7.5V8.5',
      key: '1sq4an',
    },
  ],
  [
    'path',
    {
      d: 'M2 15.5C2 15.5 3.7715 15.3213 4.5 16C5.3395 16.7822 5.5286 17.8769 5 18.8953',
      key: 'drm9ch',
    },
  ],
  [
    'path',
    {
      d: 'M2 15.5V18.1595L2.1662 18.2185C2.1662 18.2185 3.8933 18.631 5 18.8953',
      key: '5ptt92',
    },
  ],
  [
    'path',
    {
      d: 'M2 9.5C2 9.5 2 14.5 2 15.5',
      key: '147mxx',
    },
  ],
  [
    'path',
    {
      d: 'M2 9.5C2 9.5 3.7972 9.7053 4.5 9C5.0356 8.4625 5.2522 8.1674 5.1589 7.1722',
      key: '1sp49q',
    },
  ],
  [
    'path',
    {
      d: 'M2 9.5V6.4033L2.3311 6.5179C2.3311 6.5179 4.0546 6.9166 5.1589 7.1722',
      key: 'bg4qq6',
    },
  ],
  [
    'path',
    {
      d: 'M22 14.5V8.5',
      key: '2lnevw',
    },
  ],
  [
    'path',
    {
      d: 'M5.1589 7.1722C7 7.5 9.5838 6.8909 12 5.9941C14.4162 5.0973 17.4155 5.546 19.5 6',
      key: '1taos4',
    },
  ],
  [
    'path',
    {
      d: 'M6.8169 13.561C6.6997 13.6783 6.5408 13.7441 6.375 13.7441C6.2092 13.7441 6.0503 13.6783 5.9331 13.561C5.8159 13.4438 5.75 13.2849 5.75 13.1191C5.75 12.9533 5.8159 12.7944 5.9331 12.6772C6.0503 12.5599 6.2092 12.4941 6.375 12.4941C6.5408 12.4941 6.6997 12.5599 6.8169 12.6772C6.9342 12.7944 7 12.9533 7 13.1191C7 13.2849 6.9342 13.4438 6.8169 13.561Z',
      key: '1pvbzx',
    },
  ],
]);
